import { Educapoint } from "./Educapoint";
import { COLORS } from '@educaplay/core/utils';

/**
 * @returns {React.ReactNode} - return an Animation of Point. 
 */
export function AnimationPoint() {

    return ( 
        <Educapoint color={COLORS.primary}/>
            
    );

}